import React from 'react'

import { useFocusMode } from '../../../../blocs/useFocusMode'

import { FocusAudienceCount } from './FocusAudienceCount/FocusAudienceCount'
import { FocusClock } from './FocusClock/FocusClock'
import { FocusLiveTimer } from './FocusLiveTimer/FocusLiveTimer'
import { FocusReactions } from './FocusReactions/FocusReactions'
import { FocusStopwatch } from './FocusStopwatch/FocusStopwatch'
import { FocusTimer } from './FocusTimer/FocusTimer'

import './FocusFooter.scss'

const FocusFooter = () => {
  const { widgets } = useFocusMode()

  return (
    <div className="focus-footer">
      {widgets.liveTimer && (
        <div className="focus-widget-container">
          <FocusLiveTimer />
        </div>
      )}

      {widgets.audienceCount && (
        <div className="focus-widget-container">
          <FocusAudienceCount />
        </div>
      )}

      {widgets.timer && (
        <div className="focus-widget-container">
          <FocusTimer />
        </div>
      )}

      {widgets.clock && (
        <div className="focus-widget-container">
          <FocusClock />
        </div>
      )}

      {widgets.stopwatch && (
        <div className="focus-widget-container">
          <FocusStopwatch />
        </div>
      )}

      {widgets.reactions && (
        <div className="focus-widget-container">
          <FocusReactions />
        </div>
      )}
    </div>
  )
}

export { FocusFooter }
